import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

// i18n
import { withTranslation } from 'react-i18next';

// redux
import { push } from '../../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { authUtil } from '../../../utils';

import Avatar from '../../../components/avatar/avatar';

export class BroadcastMessageList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.fetchReportData();
  }

  fetchReportData = async () => {
    const { t, filter, messageId } = this.props;
    if (filter) {
      this.setState({ loading: true });
      const idToken = await authUtil.getFreshIdToken();
      fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/broadcasts/${messageId}/data?filter=${filter}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'br-token': idToken
          }
        })
        .then((res) => {
          if (!res.ok) {
            throw new Error(res.error);
          } else {
            return res.json();
          }
        })
        .then((reportData) => {
          if (reportData !== undefined) {
            this.setState({
              reportData
            });
          }
        })
        .catch(() => {
          toast.error(t('SomethingWentWrong'));
        })
        .finally(() => {
          this.setState({
            loading: false
          });
        });
    }
  }

  render() {
    const { t } = this.props;
    const { reportData = [], loading } = this.state;

    return (
      <table className="br-table" aria-label={t('Seen', 'Seen')}>
        <thead>
          <tr>
            <th scope="col">{t('User')}</th>
            <th scope="col">{t('Sent')}</th>
            <th scope="col">{t('Seen')}</th>
          </tr>
        </thead>
        <tbody>
          {
            reportData.length === 0 && (
              <tr><td colSpan={3}>
                <p role="status">{loading ? t('Loading') : t('NothingHere')}</p>
              </td></tr>
            )
          }
          {
            reportData.map(data => (
              <tr key={data._id}>
                <td>
                  <Avatar userId={data.user._id} name={data.user.displayName} diameter={20} />
                  <Avatar
                    userId={data.user._id}
                    name={data.user.displayName}
                    nameOnly
                    style={{ marginLeft: 5 }}
                  />
                </td>
                <td><time dateTime={data.createdAt}>{moment(data.createdAt).format('lll')}</time></td>
                <td><time dateTime={data.seenAt}>{moment(data.seenAt).format('lll')}</time></td>
              </tr>
            ))
          }
        </tbody>
      </table>
    );
  }
}


// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  userProfile: state.user.userProfile
});

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(BroadcastMessageList)));
